















import Scope from '@/views/atoms/Scope.vue'
import PopupLast from '@/views/templates/tenugui/PopupLast.vue'
import PopupThirdQuiz from '@/views/templates/tenugui/PopupThirdQuiz.vue'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'

export default {
  components: {
    Scope
    PopupLast
    PopupThirdQuiz
    ReshowQuiz
  }

  data: () ->
    showPopup: 0
    showQuizPopup: 0
    isFirstScroll: false


  mounted: () ->
    requestAnimationFrame(() =>
      window.addEventListener('scroll', @_onScroll)
    )

  destroyed: () ->
    window.removeEventListener('scroll', @_onScroll)

  methods: {
    reshowQuiz: (e) ->
      @showQuizPopup = 1
    show_popup: () ->
      @showPopup = 1
    close_popup: ()->
      @showPopup = 2
    close_quiz_popup: (code) ->
      console.log code
      @showQuizPopup = code
    add_point: (point) ->
      @$emit('addPoint', point)
    _onScroll: () ->
      wk = document.querySelector('.space03').offsetTop - window.scrollY
      if wk < 0
        return
      if wk - window.innerHeight <= 0
        if !@isFirstScroll
          @showQuizPopup = 1
          @isFirstScroll = true
  }
}
